// ITEM_ACTIVE
export const ITEM_SELECTED = "ITEM_SELECTED";
export const ACTION_GET_TEST_SUCCEEDED = "ACTION_GET_TEST_SUCCEEDED";
export const CHAPTER_SELECTED = 'CHAPTER_SELECTED';


//TEST_ACTIONS
export const ACTION_GET_TEST_STARTED = "ACTION_GET_TEST_STARTED";
export const ACTION_GET_TEST_FAILED = "ACTION_GET_TEST_FAILED";
export const ACTION_POST_TEST_SUCCEEDED = "ACTION_POST_TEST_SUCCEEDED";
export const ACTION_POST_TEST_FAILED = 'ACTION_POST_TEST_FAILED';


// WINDOW
export const WINDOW_WIDTH = "WINDOW_WIDTH";
export const WINDOW_HEIGHT = "WINDOW_HEIGHT";


//NAV BAR
export const CLOSE_BUTTON = "CLOSE_BUTTON";
export const CLOSE_NAV_BAR = "CLOSE_NAV_BAR";


//BLOCK
export const BLOCK_IS_ACTIVE = 'BLOCK_IS_ACTIVE';

export const ITEM_IS_ACTIVE = 'ITEM_IS_ACTIVE';

//CONTENT
export const ACTION_GET_CHAPTER_LIST_STARTED = "ACTION_GET_CHAPTER_LIST_STARTED";
export const ACTION_GET_CHAPTER_LIST_SUCCEEDED = "ACTION_GET_CHAPTER_LIST_SUCCEEDED";
export const ACTION_GET_CHAPTER_LIST_FAILED = "ACTION_GET_CHAPTER_LIST_FAILED";


export const CONTENT_LOADING = 'ACTION_CONTENT_LOADING';
export const CONTENT_LOADED = 'ACTION_CONTENT_LOADED';
export const CONTENT_CHAPTERS = 'CONTENT_CHAPTERS';


export const CURRENT_ITEM = 'CURRENT_ITEM';
export const NEXT_ITEM = 'NEXT_ITEM';
export const PREVIOUS_ITEM = 'PREVIOUS_ITEM';


export const CHAPTER_CONTENT_LOADED_SUCCESS = 'CHAPTER_CONTENT_LOADED_SUCCESS';
export const CHAPTER_CONTENT_LOADED_FAILED = 'CHAPTER_CONTENT_LOADED_FAILED';

export const CURRENT_DOMAIN_NAME = "CURRENT_DOMAIN_NAME";


export const ACTION_EMPTY_NODE = "EMPTY_NODE";
export const ACTION_APPROVED = 'APPROVED_COURSE';




// WEBPACK FOOTER //
// ./src/actions/actionTypes.js